import React from 'react';
import './assets/css/style.css';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import RoutesApp from './routing/RoutesApp';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter as Router } from 'react-router-dom';
import { ReactQueryDevtools } from 'react-query/devtools';
import { GeneralContext } from "./context/GeneralContext";

const queryClient = new QueryClient()

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient} >
		<GeneralContext>
			<Router>
				<RoutesApp />
			</Router>
		</GeneralContext>
	<ReactQueryDevtools initialIsOpen={false} />
	</QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
